import React from "react";

import { TileBase, TileBaseProps } from "../TileBase/TileBase";

export type ImagePreviewTileAction =
  | "SELECT"
  | "DOUBLE_CLICK"
  | "OPEN_CONTEXT_MENU";

interface ImagePreviewTileProps extends TileBaseProps {
  src: string;
  alt: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
  onAction?: (event: React.MouseEvent, action: ImagePreviewTileAction) => void;
}

export const ImagePreviewTile = (props: ImagePreviewTileProps) => {
  const { src, alt, imgProps = {}, onAction, ...rest } = props;

  const handleAction =
    (action: ImagePreviewTileAction) => (event: React.MouseEvent) => {
      onAction?.(event, action);
    };

  return (
    <TileBase
      onClick={handleAction("SELECT")}
      onDoubleClick={handleAction("DOUBLE_CLICK")}
      onContextMenu={handleAction("OPEN_CONTEXT_MENU")}
      {...rest}
    >
      <img src={src} alt={alt} {...imgProps} />
    </TileBase>
  );
};
